import { get2 } from "@/shared/axios";
import useAuthHook from "@/shared/hooks/useAuthHook";
import { LayoutData } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useLayoutQuery = () => {
  const { isAuth } = useAuthHook();
  return useQuery<LayoutData>({
    queryKey: ["layout"],
    queryFn: () => get2("/cms/v1/complete-start-navigation"),
    refetchOnWindowFocus: false,
    enabled: isAuth,
    refetchOnMount: false,
  });
};

export default useLayoutQuery;
